import { fetchWrapperPublic } from "helpers/fetch-wrapper";
import { API_BASE_URL } from "helpers/constants";

export class AdsRequests {
    static async listCampaigns(): Promise<Response> {
        return await fetchWrapperPublic.get(`${API_BASE_URL}/ads/campaigns/`);
    }

    static async createCampaign(data: any): Promise<Response> {
        return await fetchWrapperPublic.post(`${API_BASE_URL}/ads/campaigns/`, data);
    }

    static async getCampaign(campaignId: string): Promise<Response> {
        return await fetchWrapperPublic.get(`${API_BASE_URL}/ads/campaigns/${encodeURIComponent(campaignId)}/`);
    }

    static async requestChange(campaignId: string, data: any): Promise<Response> {
        return await fetchWrapperPublic.post(
            `${API_BASE_URL}/ads/campaigns/${encodeURIComponent(campaignId)}/request/`, data,
        );
    }

    static async getSummary(days: number): Promise<Response> {
        return await fetchWrapperPublic.get(`${API_BASE_URL}/ads/summary/?days=${days}`);
    }

    static async uploadCreative(file: File): Promise<Response> {
        const data = new FormData();
        data.append("file", file);
        return await fetchWrapperPublic.post(`${API_BASE_URL}/ads/creatives/`, data);
    }
}
